<template>
  <div style="clear: both;">
    <v-container>
      <v-col>
        <!--xs12 sm="6"-->
        <h1>Welcome</h1>
        <p>
          Welcome to your new single-page application, built with
          <a href="https://vuejs.org" target="_blank">Vue.js</a>.
        </p>
        <p>
          {{ `It looks like your name is ${user.displayName} according to the Graph API` }}
        </p>
      </v-col>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'Home',
  data() {
    return {
      msg: ''
    }
  },
  computed: {
    ...mapGetters('currentUser', ['CURRENTUSER']),
    ...mapState('currentUser', ['user'])
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
